"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clientAwsS = require("@devsta/client-aws-s3");

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

require("../styles/_new-post-modal.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PostModal = /*#__PURE__*/function (_Component) {
  _inherits(PostModal, _Component);

  var _super = _createSuper(PostModal);

  function PostModal(props) {
    var _this;

    _classCallCheck(this, PostModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onFieldChange", function (field) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          fields: _objectSpread(_objectSpread({}, prevState.fields), field)
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addThumbnailToInspiration", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var organisationId, inspirationId, file, _this$props, apolloClient, updateInspiration;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                organisationId = _ref.organisationId, inspirationId = _ref.inspirationId, file = _ref.file;
                _this$props = _this.props, apolloClient = _this$props.apolloClient, updateInspiration = _this$props.updateInspiration;
                _context.prev = 2;
                _context.next = 5;
                return (0, _clientAwsS.uploadFile)({
                  apiClient: apolloClient,
                  file: file,
                  bucketKey: "organisation/".concat(organisationId, "/inspiration/").concat(inspirationId, "/file-THUMBNAIL"),
                  organisationId: organisationId
                });

              case 5:
                return _context.abrupt("return", updateInspiration({
                  inspirationId: inspirationId,
                  input: {
                    isCustomThumbnail: true
                  }
                }));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", (0, _commonReact.notify)({
                  content: 'Something went wrong.',
                  type: 'error'
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 8]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onThumbnailChange", function (_ref3) {
      var file = _ref3.file,
          previewUrl = _ref3.previewUrl;

      _this.setState({
        thumbnailFile: file,
        thumbnailUrl: previewUrl
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function (e, inspirationId) {
      var closePostModal = _this.props.closePostModal;
      closePostModal(inspirationId);
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, organisationId, assetId, createInspiration, outputId, _this$state$fields, title, description, tagLine, referenceLink, _this$state$fields$ca, campaigns, postToSave, _yield$createInspirat, data, thumbnailFile, inspirationId;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, organisationId = _this$props2.organisationId, assetId = _this$props2.assetId, createInspiration = _this$props2.createInspiration, outputId = _this$props2.outputId;
              _this$state$fields = _this.state.fields, title = _this$state$fields.title, description = _this$state$fields.description, tagLine = _this$state$fields.tagLine, referenceLink = _this$state$fields.referenceLink, _this$state$fields$ca = _this$state$fields.campaigns, campaigns = _this$state$fields$ca === void 0 ? [] : _this$state$fields$ca;
              postToSave = {
                organisationId: organisationId,
                assetId: assetId,
                title: title,
                description: description,
                tagLine: tagLine,
                referenceLink: referenceLink,
                setCampaignIds: campaigns.map(function (campaign) {
                  return campaign.value;
                })
              };
              _context2.next = 5;
              return createInspiration({
                post: postToSave,
                outputId: outputId
              });

            case 5:
              _yield$createInspirat = _context2.sent;
              data = _yield$createInspirat.data;

              if (!(!data || !data.createInspiration)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", null);

            case 9:
              thumbnailFile = _this.state.thumbnailFile;
              inspirationId = data.createInspiration.inspirationId;

              if (!thumbnailFile) {
                _context2.next = 14;
                break;
              }

              _context2.next = 14;
              return _this.addThumbnailToInspiration({
                organisationId: organisationId,
                file: thumbnailFile,
                inspirationId: inspirationId
              });

            case 14:
              return _context2.abrupt("return", _this.onClose(undefined, inspirationId));

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _this.state = {
      assetId: props.assetId,
      fields: {},
      thumbnailFile: void 0,
      thumbnailUrl: void 0,
      publishPost: false
    };
    return _this;
  }

  _createClass(PostModal, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          organisationId = _this$props3.organisationId,
          apolloClient = _this$props3.apolloClient,
          isVisible = _this$props3.isVisible,
          assetId = _this$props3.assetId;
      var _this$state = this.state,
          thumbnailUrl = _this$state.thumbnailUrl,
          fields = _this$state.fields;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
        visible: isVisible,
        title: "New Inspiration Post",
        onClose: this.onClose,
        saveText: "Save & Continue",
        onSave: this.onSave,
        saveDisabled: !(fields.title && fields.description && assetId),
        onBack: true,
        stayOpenOnSave: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "new-post-modal"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.PostDetailsForm, {
        organisationId: organisationId,
        onFieldChange: this.onFieldChange,
        onThumbnailChange: this.onThumbnailChange,
        post: {},
        apolloClient: apolloClient,
        assetId: assetId,
        thumbnailUrl: thumbnailUrl
      }))));
    }
  }]);

  return PostModal;
}(_react.Component);

exports.default = PostModal;